import { TextLink } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";

/** 参加規約の文言を表示するコンポーネント */
export const AgreementContent = () => {
  return (
    <Styled.DivAttentionWrapper>
      <Styled.Heading size="M">イベント割参加規約</Styled.Heading>

      <div>
        <Styled.ParText>
          本商品はイベント需要喚起事業（イベント割事業）給付金給付規程に基づき実施されるイベント割事業の対象として登録されたイベントの対象商品です。
        </Styled.ParText>

        <br />

        <Styled.ParText>
          イベント割事業の利用者は、同事業の対象商品の購入申込みをもって、イベント割参加規約（以下「規約」といいます。）
          <TextLink
            color="BLUE900"
            href="https://wakuwari.go.jp/assets/pdf/participation_terms_sankakiyaku_japanese.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://wakuwari.go.jp/assets/pdf/participation_terms_sankakiyaku_japanese.pdf
          </TextLink>
          の定めを合同会社DMM.comとの間の契約の内容とする旨を合意し、合同会社DMM.comに対し、イベント割事業給付金の申請及び受領等を委任いたします。
        </Styled.ParText>

        <br />

        <Styled.ParText>なお、規約には、以下に掲げる事項が定められています。 </Styled.ParText>

        <br />

        <Styled.ParText>
          ① イベント割事業給付金の申請と精算に係る事項 （給付金の申請と受領の委任に関する事項を含みます。）
        </Styled.ParText>

        <Styled.ParText>② 対象商品を複数枚購入する購入者に関する事項</Styled.ParText>

        <Styled.ParText>③ 個人情報の利用目的及び個人データの第三者提供に関する事項</Styled.ParText>

        <Styled.ParText>
          ④ 新型コロナウイルス感染症に関し、イベント参加者に遵守が求められる事項
          <Styled.UlWrapper>
            <Styled.List>・複数枚購入する場合、代表者（購入者）は有事の際に同行者への連絡を行うこと</Styled.List>

            <Styled.List>
              ・3回目の接種が完了していることを示すワクチン接種歴、又は陰性の検査結果の提示を自ら又は購入者を通じて同意すること（ただし、オンライン配信のみのイベントは除く。）
            </Styled.List>

            <Styled.List>
              ・上記証明書等の提示を求められた場合には、自ら又は購入者を通じて提示すること（ただし、オンライン配信のみのイベントは除く。）
            </Styled.List>

            <Styled.List>
              ※なお、上記証明書等について、偽造等をした場合は、刑法等の罪に問われる可能性があります。
            </Styled.List>
          </Styled.UlWrapper>
        </Styled.ParText>

        <Styled.ParText>⑤ 規約の変更に関する事項</Styled.ParText>

        <Styled.ParText>⑥ その他イベント割事業を利用するにあたり遵守が求められる事項等</Styled.ParText>
      </div>
    </Styled.DivAttentionWrapper>
  );
};
